module.exports = __webpack_public_path__ + "static/media/hardeeville.4c2a8068.jpg";